import React from 'react'

const ProfileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="56" height="56.7" viewBox="0 0 80 81" {...props}>
    <rect width="80" height="81" fill="#fff" />

    <circle
      cx="40"
      cy="40.093"
      r="38.387"
      fill="#fff"
      stroke="#EEE"
      strokeWidth="3.227"
    />
    <g clipPath="url(#clip0)">
      <path
        d="M42.392 38.402h4.082M42.392 41.668h4.082"
        stroke="#78BE20"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.923 31.871H30.962c-.451 0-.816.366-.816.816v14.696c0 .45.365.816.816.816h17.961c.45 0 .816-.366.816-.816V32.687c0-.45-.366-.816-.816-.816Z"
        stroke="#78BE20"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#fff"
      />
      <path
        d="M36.677 41.668c1.352 0 2.449-1.097 2.449-2.449 0-1.353-1.097-2.449-2.449-2.449-1.353 0-2.45 1.096-2.45 2.449 0 1.352 1.097 2.449 2.45 2.449Z"
        stroke="#78BE20"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#fff"
      />
      <path
        d="M33.411 44.117c.362-1.408 1.744-2.449 3.266-2.449s2.905 1.04 3.266 2.449"
        stroke="#78BE20"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="26.125"
          height="26.125"
          fill="#fff"
          transform="translate(26.88 26.973)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default ProfileIcon
